<form [formGroup]="targeted_form" (ngSubmit)="onSubmit()" autocomplete="off">

    <div style="align-items: center;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">Создать характеристику</h2>
                </div>
                <div class="modal-body">
                    <div style="min-height: 380;max-height: 380; max-width: 430px; padding: 15px; margin: 0 auto;">

                        <!--TypeTargeted-->
                        <div class="form-group">
                            <label>Тип</label>
                            <select class="form-control" (change)="changeType($event)" formControlName="TypeTargeted">
                                <option *ngFor="let type of type_targeted" [ngValue]="type.Name">
                                    {{ type.Name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Название</label>
                            <input type="text" formControlName="Name" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f['Name'].errors }" />
                            <div *ngIf="submitted && f['Name'].errors" class="invalid-feedback">
                                <div *ngIf="f['Name'].errors['required']">Поле
                                    не может быть пустым
                                </div>
                            </div>
                        </div>

                        <!--Volume-->
                        <div class="form-group">
                            <label>Значение</label>
                            <input type="text" formControlName="Volume" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f['Volume'].errors }" />                            
                        </div>




                    </div>
                </div>


                <div class="modal-footer" style="align-items: center;">
                    <div class="form-group">
                        <button mat-button mat-dialog-close class="btn btn-danger">Отмена</button>
                        <button mat-button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>